import React, { useEffect, useMemo, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import { json, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import ToastDialog from "components/Common/ToastDialog";
import Select from "react-select";
import Loader from "react-spinner-loader";
import { parse, format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ColumnDragDrop from '../../hooks/columnDragDrop';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as XLSX from 'xlsx';

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  FormFeedback,
  Form,
  Label,
  Table,
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

//redux
import {
  getDeal,
  getDealForTabs,
  allFinancier,
  downloadDealPdf,
  getDealInfo,
  addDealStatus,
  dealFinancierDetails,
} from "../../http/fundLync/deal.helper";
import { getEntityDetails } from "http/fundLync/entityAndAddress.helper";
import { dateFormat, decryptedValue, formatNumberToCrores, formatNumberWithCommas, isPermission, uId } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import {
  callGetCIUser,
  callAssignDealFinancier,
  callAssignToMeDealFinancier,
  callShowInterestFinancier,
  callGetFinancier,
  callStatusCount,
  callDeleteDeals
} from "../../http/fundLync/dealFinancier";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { formatDateString1 } from "pages/EntityDashboard/borrowingProfile";
import { callFinancierList } from "http/fundLync/common.helper";
import { getlistingPreference } from "http/fundLync/listingPreferenceHelper";
import { callGetProveBaseApi } from "http/fundLync/entityDocuments.helper";
import debounce from 'lodash.debounce';
import { TouchBackend } from "react-dnd-touch-backend";
import { isMobile } from "react-device-detect";
import DeleteModal from "components/Common/DeleteModal";

const TableActionsComponent = (rowData, handleShowFinanciers,handleShowFinanciersDetails, handleShowStatusBucket, assignFunc, assignToMeFunc, downloadDealDetailsPdf, dealList, setDealList,setPagination,setStatusCount) => {
  
  const navigate = useNavigate();
  const [isAssignmentPermisssion, setIsAssignmentPermisssion] = useState(false)
  const [isAssignmentForMePermisssion, setIsAssignmentForMePermisssion] = useState(false)
  const user = decryptedValue(localStorage.getItem("user"));
  const [isApprovePermission, setIsApprovePermission] = useState(false)
  const [isMouPermission, setIsMouPermission] = useState(false)
  const [isDeletePermission, setIsDeletePermission] = useState(false);
  const [showDealModal, setShowDealModal] = useState(false); 
  const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
  const [toastInfo, setToastInfo] = useState({
    showToast: false,
    message: "",
    role: "",
  });
  const [dealToDelete, setDealToDelete] = useState(null);
  const checkPermissions = async () => {
    const assignment = await isPermission("assign", "create_permission");
    const leadAssignment = await isPermission(
      "lead_assign",
      "create_permission"
    );
    const isAddNew = await isPermission("approve_deal", "approve_permission");
    const isAddMou = await isPermission("mou", "create_permission");
    const isDelete = await isPermission("deal_detail", "delete_permission");
    setIsAssignmentPermisssion(leadAssignment);
    setIsAssignmentForMePermisssion(assignment);
    setIsApprovePermission(isAddNew);
    setIsMouPermission(isAddMou);
    setIsDeletePermission(isDelete);
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const navigateToEditRoles = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/editDeal?id=${encodeURIComponent(encryptedId)}`
    );
  };

  const navigateToViewRoles = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/viewDeal?id=${encodeURIComponent(encryptedId)}`
    );
  };

  const navigateToauditLogs = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/dealTimeLine?id=${encodeURIComponent(encryptedId)}`
    );
  };
  const navigateToAddNotes = (id, rowData) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/add-notes?id=${encodeURIComponent(
        encryptedId
      )}&dealName=${rowData.dealName || ""}&anchor=${
        rowData.anchor?.entityName || ""
      }&counterparty=${rowData.counterparty?.entityName || ""}`
    );
  };
  const navigateToAddTask = (id, rowData) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/add-task?id=${encryptedId}&type=deal&entityId=${
        rowData.entity?.id || ""
      }&dealName=${rowData.dealName || ""}&entityName=${
        rowData.entity?.entityName || ""
      }`
    );
  };
  const navigateToAddMeeting = (id, rowData) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/schedule-meeting?id=${encodeURIComponent(
        encryptedId
      )}&type=deal&entityId=${rowData.entity?.id || ""}&dealName=${
        rowData.dealName || ""
      }&entityName=${rowData.entity?.entityName || ""}`
    );
  };
  const navigateToEmandate = (id, rowData) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/emandate?id=${encodeURIComponent(encryptedId)}`
    );
  };

  const navigateToMOU = (id, rowData) => {
    const encryptedId = btoa(id.toString());
    navigate(
      `/${user.roleName}/moutemplate?id=${encodeURIComponent(encryptedId)}`
    );
  };
  const handleDeleteDeal = async () => {
    if (dealToDelete) {
      try {
        const response = await callDeleteDeals({ id: dealToDelete });
        if (response.code === 201 && response.status === true) {
          // Update the deals state to remove the deleted deal
          setDealList(prevDeals => prevDeals.filter(deal => deal.id !== dealToDelete));
          setPagination(prevPagination => ({
            ...prevPagination,
            totalRecords: prevPagination.totalRecords - 1 
        }));
        const user = decryptedValue(localStorage.getItem("user"));
        const filterType = "";
        const filter = []; 
        await callStatusCount({ user, filterType, filter})
            .then((statusResponse) => {
                if (statusResponse.status) {
                    setStatusCount(statusResponse.data);
                }
            })
         
         setToastInfo({
            message: response.message,
            showToast: true,
            role: "success",
          });
        } else {
          setToastInfo({
            message: response.message || "Failed to fetch data",
            showToast: true,
            role: "error",
          });
        }
      } catch (error) {
        setToastInfo({
          message: error.message || "Something went wrong",
          showToast: true,
          role: "error",
        });
      } finally {
        setShowCommonDialog({ isShow: false });
        setDealToDelete(null);
      }
    }
  };
  const openCommonDialog = (message, dealId) => {
    setDealToDelete(dealId); // Set the deal ID to be deleted
    setShowCommonDialog({ isShow: true, message });
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
      {(rowData.status != 15) && (rowData.status != 11) && (rowData.status != 12) && (rowData.status != 2 || isApprovePermission) ? (
          <DropdownItem
            onClick={() => { navigateToEditRoles(rowData.id) }}
          >
            <i className="mdi mdi-pencil font-size-16 text-success me-1" id="editdealtooltip-edit"></i>
            Edit
            <UncontrolledTooltip placement="top" target="editdealtooltip-edit">
              Edit
            </UncontrolledTooltip>
          </DropdownItem>
        ) : (
          <div className="d-inline-block" id="editdealtooltip-edit" style={{ opacity: 0.5, cursor: 'not-allowed' }}>
            <DropdownItem
              onClick={() => {}}
              disabled
            >
              <i className="mdi mdi-pencil font-size-16 text-mute me-1"></i>
              Edit
            </DropdownItem>
            <UncontrolledTooltip placement="top" target="editdealtooltip-edit">
            Editing not Available for Live, Approved and Rejected Deals
            </UncontrolledTooltip>
          </div>
        )}

        <DropdownItem
          onClick={() => {
            navigateToViewRoles(rowData.id);
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="editdealtooltipview"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="editdealtooltipview">
            View
          </UncontrolledTooltip>
        </DropdownItem>

        {/* <DropdownItem
          onClick={() => { navigateToauditLogs(rowData.id) }
          }
        >
          <i className="bx bx-log-in-circle font-size-16 text-success me-1" id="editdealtooltip-audit"></i>
          Audit Logs
          <UncontrolledTooltip placement="top" target="editdealtooltip-audit">
            Audit Logs
          </UncontrolledTooltip>
        </DropdownItem> */}

        <DropdownItem
          onClick={() => {
            handleShowFinanciers(rowData);
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="editdealtooltip-int-fi"
          ></i>
          Financier Status
          <UncontrolledTooltip placement="top" target="editdealtooltip-int-fi">
            Financier Status
          </UncontrolledTooltip>
        </DropdownItem>

        <DropdownItem
          onClick={() => {
            handleShowStatusBucket(rowData);
          }}
        >
          <i
            className="mdi mdi-checkbox-marked-circle-outline font-size-16 text-success me-1"
            id="editdealtooltip-int-fi"
          ></i>
          Change Deal Status
          <UncontrolledTooltip placement="top" target="editdealtooltip-int-fi">
            Change Deal Status
          </UncontrolledTooltip>
        </DropdownItem>

        {isAssignmentPermisssion && rowData.assignedTo == null && (
          <DropdownItem
            onClick={() => {
              assignFunc(rowData);
            }}
          >
            <i
              className="mdi mdi-eye font-size-16 text-success me-1"
              id="editdealtooltip"
            ></i>
            Assign
            <UncontrolledTooltip placement="top" target="editdealtooltip">
              Assign
            </UncontrolledTooltip>
          </DropdownItem>
        )}

        {isAssignmentForMePermisssion && rowData.assignedTo == null && (
          <DropdownItem
            onClick={() => {
              assignToMeFunc(rowData);
            }}
          >
            <i
              className="mdi mdi-eye font-size-16 text-success me-1"
              id="editdealtooltip-assign-me"
            ></i>
            Assign To Me
            <UncontrolledTooltip
              placement="top"
              target="editdealtooltip-assign-me"
            >
              Assign To Me
            </UncontrolledTooltip>
          </DropdownItem>
        )}

        {isAssignmentPermisssion && rowData.assignedTo !== null && (
          <DropdownItem
            onClick={() => {
              assignFunc(rowData);
            }}
          >
            <i
              className="mdi mdi-eye font-size-16 text-success me-1"
              id="editdealtooltip-reassign"
            ></i>
            ReAssign
            <UncontrolledTooltip
              placement="top"
              target="editdealtooltip-reassign"
            >
              ReAssign
            </UncontrolledTooltip>
          </DropdownItem>
        )}

        {/* <DropdownItem
          onClick={() => { downloadDealDetailsPdf(rowData.id) }
          }
        >
          <i className="mdi mdi-download font-size-16 text-success me-1" id="editdealtooltip2"></i>
          Download
          <UncontrolledTooltip placement="top" target="editdealtooltip2">
            Download
          </UncontrolledTooltip>
        </DropdownItem> */}
        <DropdownItem onClick={() => navigateToAddNotes(rowData.id, rowData)}>
          <i
            className="mdi mdi-note-plus font-size-16 text-success me-1"
            id="addNotesTooltip"
          ></i>
          Add Notes
          <UncontrolledTooltip placement="top" target="addNotesTooltip">
            Add Notes
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem onClick={() => navigateToAddTask(rowData.id, rowData)}>
          <i
            className="mdi mdi-note-plus font-size-16 text-success me-1"
            id="addTaskTooltip"
          ></i>
          Add Task
          <UncontrolledTooltip placement="top" target="addTaskTooltip">
            Add Task
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem onClick={() => navigateToAddMeeting(rowData.id, rowData)}>
          <i
            className="mdi mdi-note-plus font-size-16 text-success me-1"
            id="addMeetingTooltip"
          ></i>
          Add Meeting
          <UncontrolledTooltip placement="top" target="addMeetingTooltip">
            Add Meeting
          </UncontrolledTooltip>
        </DropdownItem>
        {/* Temporary Emandate */}
        <DropdownItem onClick={() => navigateToEmandate(rowData.id, rowData)}>
          <i
            className="mdi mdi-note-plus font-size-16 text-success me-1"
            id="addmandateTooltip"
          ></i>
          E-Mandate
          <UncontrolledTooltip placement="top" target="addmandateTooltip">
            E-Mandate
          </UncontrolledTooltip>
        </DropdownItem>
        {isMouPermission &&
          (rowData.prospectiveProduct == "TradEasy" ||
            rowData.prospectiveProduct == "PayEarly") && (
            <DropdownItem onClick={() => navigateToMOU(rowData.id, rowData)}>
              <i
                className="mdi mdi-note-plus font-size-16 text-success me-1"
                id="addmouTooltip"
              ></i>
              MOU
              <UncontrolledTooltip placement="top" target="addmouTooltip">
                MOU
              </UncontrolledTooltip>
            </DropdownItem>
          )}

          {isDeletePermission && 
           (rowData.status != 15) && (rowData.status != 11) && (rowData.status != 12) && (
       <DropdownItem onClick={() => openCommonDialog("Are you sure you want to delete this deal?", rowData.id)}>
          <i className="mdi mdi-delete font-size-16 text-success me-1" id="deleteTooltip"></i>
          Delete
          <UncontrolledTooltip placement="top" target="deleteTooltip">Delete</UncontrolledTooltip>
        </DropdownItem>
          )}
      </DropdownMenu>

      {/* Modals and Dialogs */}
      <DeleteModal
        msg={showCommonDialog.message}
        show={showCommonDialog.isShow}
        onDeleteClick={handleDeleteDeal} // Call the delete function
        onCloseClick={() => setShowCommonDialog({ isShow: false })}
      />
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </UncontrolledDropdown>
  );
};

const DealList = (props) => {
  //meta title
  document.title = "List Deal | FundLync";
  const navigate = useNavigate();
  const [dealList, setDealList] = useState([]);
  const [isNewDealPermission, setIsNewDealPermission] = useState(false);
  const [isSelectFieldPermission, setIsSelectFieldPermission] = useState(false)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeTab, setPageSizeTab] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState([]);
  const [filterValueTabs, setFilterValueTabs] = useState([]);
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [customTab, setCustomTab] = useState("1");
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: [
      "Action",
      "isSecured",
      "interested",
      "assigned",
      "assignedToUser",
      "commercials",
      "financierData"
    ],
  });
  const [modal, setModal] = useState(false);
  const [subscribemodal, setSubscribemodal] = useState(false);
  const [financeirDetailsmodal, setFinanceirDetailsmodal] = useState(false);
  const [assignmodal, setAssignmodal] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [dealStatusBucketList, setDealStatusBucketList] = useState([]);
  const [selectedDealId, setSelectedDealId] = useState("");
  const [userList, setUserList] = useState([]);
  const [financierList, setFinancierList] = useState([]);
  const [interestedFinancierList, setInterestedFinancierList] = useState([]);
  const [acceptedFinancierList, setAcceptedFinancierList] = useState([]);
  const [rejectedFinancierList, setRejectedFinancierList] = useState([]);
  const [isFinOperationPermission, setIsFinOperationPermission] =
    useState(false);

  const [toastInfo, setToastInfo] = useState({
    showToast: false,
    message: "",
    role: "",
  });
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [statusCount, setStatusCount] = useState({});
  const [dealInfo, setDealInfo] = useState(null);
  const [isAssignmentForMePermisssion, setIsAssignmentForMePermisssion] =
    useState(false);
  const user = decryptedValue(localStorage.getItem("user"));
  const [loader, setLoader] = useState(false);
  const [users, setUser] = useState("");
  const [showInterestedFinDropdown, setShowInterestedFinDropdown] =
    useState(false);
  const [showAcceptedFinDropdown, setShowAcceptedFinDropdown] = useState(false);
  const [showRejectedFinDropdown, setShowRejectedFinDropdown] = useState(false);
  const [selectedMultiAccept, setSelectedMultiAccept] = useState([]);
  const [selectedMultiReject, setSelectedMultiReject] = useState([]);
  const [selectedMultiAcceptOptions, setSelectedMultiAcceptOptions] = useState(
    []
  );
  const [selectedMultiRejectOptions, setSelectedMultiRejectOptions] = useState(
    []
  );
  const [publicSectorBankList, setPublicSectorBankList] = useState([]);
  const [allBankList, setAllrBankList] = useState([]);
  const [nbfcsBankList, setNbfcsBankList] = useState([]);
  const [lenderList, setLenderList] = useState([]);
  const [openCharges, setOpenCharges] = useState([]); 
  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");
  const dealsIds = urlParams.get("dealIDs");
  const decodedealsId = atob(dealsIds);
  const [selectedStatus, setSelectedStatus] = useState(false);
  const [renewableDueDate, setRenewableDueDate] = useState(null);
  const [unitValue, setUnitValue] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const [isDownloadPermission, setIsDownloadPermission] = useState(false)
  const [isUpcomingTabSelected, setIsUpcomingTabSelected] = useState(false)

  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  const navigateToEditEntity = (entityId) => {
    if (entityId) {
      const encryptedId = btoa(entityId.toString());
      const url = `/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(
        encryptedId
      )}`;
      return url;
    }
  };
  const navigateToDeal = (Id) => {
    if (Id) {
      const encryptedId = btoa(Id.toString());
      const url = `/${user.roleName}/viewDeal?id=${encodeURIComponent(
        encryptedId
      )}`;
      return url;
    }
  };

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = "underline";
  };
  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = "none";
  };

  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
      const truncated = text.substring(0, charLimit) + "...";
      return truncated;
    }
    return text;
  };

  const formatExpectedClosureDate = (dateString) => {
    if (!dateString) return "";
    const date = parse(dateString, "yyyy-MM", new Date());
    return format(date, "MMMM, yyyy");
  };

const defaultHideOrders = {
  entityId: 6,
  credit_rating: 9,
  turnover: 8,
  product: 2,
  assignedToUser: 4,
  loanRequirement: 5,
  commercials: 10,
  expectedClosureDate: 7,
  assignedToFirmUser: 12,
  assignedToProgramRmUser: 11,
  interested: 14,
  createdAt: 10,
  statusName: 3,
  Financiers: 13
};
  
  const columns = useMemo(
    () => [
      // {
      //   Header: 'Id',
      //   FullName: "",
      //   accessor: 'id',
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     handleChange = () => {
      //       navigateToEditEntity(cellProps.value)
      //     }
      //     return cellProps.value || '';
      //   }
      // },
      {
        Header: "Anchor Name",
        FullName: "",
        accessor: "anchorId",
        filterable: true,
        hideOrder: 6,
        Cell: ({ row }) => {
          const rowData = row.original;
          const entityId = rowData?.anchorId;
          return (
            <a
              href={navigateToEditEntity(entityId)}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                cursor: "pointer",
                color: "#21aa47",
                width: "170px",
                textDecoration: "none",
              }}
              title={rowData?.anchor?.entityName || ""}
            >
              <span>{truncateText(rowData?.anchor?.entityName, 20) || ""}</span>
            </a>
          );
        },
      },
      {
        Header: "Entity Name",
        FullName: "",
        accessor: "entityId",
        filterable: true,
        hideOrder: 6,
        Cell: ({ row }) => {
          const rowData = row.original;
          const entityId = rowData?.entity?.id;
          return (
            <a
              href={navigateToEditEntity(entityId)}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                cursor: "pointer",
                color: "#21aa47",
                width: "170px",
                textDecoration: "none",
              }}
              title={rowData?.entity?.entityName || ""}
            >
              <span>{truncateText(rowData?.entity?.entityName, 20) || ""}</span>
              {rowData?.mandate_signed != 0 && (
                <div>
                  <i
                    className="fas fa-file-alt"
                    title={rowData?.mandate_signed || ""}
                  ></i>
                </div>
              )}
            </a>
          );
        },
      },
      {
        Header: "Region",
        FullName: "",
        accessor: "entityRegion",
        filterable: true,
        hideOrder: 15,
        Cell: ({ row }) => {
          const rowData = row.original;
          return (
              <span>{capitalizeFirstLetter(rowData?.entity?.region) || ""}</span>
              
          );
        },
      },
      {
        Header: "Credit Rating",
        FullName: "",
        accessor: "credit_rating",
        filterable: true,
        hideOrder: 9,
        Cell: (cellProps) => {
          return (
            <span title={cellProps.value}>
              {truncateText(cellProps.value, 20) || ""}
            </span>
          );
        },
      },
      {
        Header: 'Turnover',
        FullName: "",
        accessor: 'turnover',
        filterable: true,
        hideOrder: 8,
        Cell: ({ row }) => {
          const rowData = row.original;
          const entityTurnOver = rowData?.entity?.turn_over;
            let amount = entityTurnOver ? '₹' + ' ' + formatNumberToCrores(entityTurnOver) : '';
            return <span title={formatNumberWithCommas(entityTurnOver)}>{amount}</span>
             
        },
      },
      {
        Header: 'Product',
        FullName: "",
        accessor: 'product',
        filterable: true,
        hideOrder:2,
        Cell: (cellProps) => {
          return (
            <span title={cellProps.value}>
              {truncateText(cellProps.value, 25) || ""}
            </span>
          );
        },
      },
      {
        Header: "RM",
        FullName: "Relationship Manager",
        accessor:
          user.entityType == "Partner" ? "assignedToUser" : "assignedPartner",
        filterable: true,
        hideOrder: 4,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          let name = "";
          if (user.entityType == "Partner") {
            if (rowData.assignedPartnerUser?.first_name) {
              name +=
                capitalizeFirstLetter(rowData.assignedPartnerUser?.first_name) +
                " ";
            }
            if (rowData.assignedPartnerUser?.last_name) {
              name +=
                capitalizeFirstLetter(rowData.assignedPartnerUser?.last_name) +
                " ";
            }
          } else {
            if (rowData.assignedToUser?.first_name) {
              name +=
                capitalizeFirstLetter(rowData.assignedToUser?.first_name) + " ";
            }
            if (rowData.assignedToUser?.last_name) {
              name +=
                capitalizeFirstLetter(rowData.assignedToUser?.last_name) + " ";
            }
          }
          return name;
        },
      },
      {
        Header: "Loan Req. ",
        FullName: "Loan Requirement",
        accessor: "loanRequirement",
        filterable: true,
        hideOrder: 5,
        Cell: (cellProps) => {
          let amount = cellProps.value ? '₹ ' + formatNumberToCrores(cellProps.value) : '';
          return (
            <span 
              title={formatNumberWithCommas(cellProps.value)}
              style={{ textAlign: 'right', display: 'block' }}
            >
              {amount}
            </span>
          );
        }
      },
      {
        Header: "Referred financiers",
        FullName: "Referred financiers",
        accessor: "financierData",
        filterable: true,
        hideOrder: 5,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          const bankNames = rowData?.financierData?.map(financier => financier.name).join(', ') || '';
          const bankNamesList = rowData?.financierData
            ?.map(financier => `• ${financier.name}`)
            .join('\n') || '';
          return (
            <span title={bankNamesList}>
              {truncateText(bankNames, 25) || ""}
            </span>
          );
        }
      },
      {
        Header: "Commercials",
        FullName: "Integration Fees/ Platform Charges/ Syndication Fees",
        accessor: "commercials",
        hideOrder: 10,
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original?.commercials;
          const formatFee = (fee) => {
            if (!fee) return null;
            const {
              Type,
              Value,
              Benchmark,
              BenchmarkRate,
              MarkupOverBenchmark,
              NVG,
              Frequency,
              Occurrence,
            } = fee;

            if (!Value && !NVG) return null;

            if (Type === "Percentage") {
              return `${Value}%`;
            }
            if (Type === "NVG") {
              const billingOccurrence =
                Frequency === "Recurring" ? Occurrence : Frequency;

              if (BenchmarkRate == 0 && MarkupOverBenchmark == 0) {
                return `${NVG}% of (Discount percentage per annum) billed on ${
                  billingOccurrence || "NA"
                } basis`;
              } else {
                return `${NVG}% of (Discount percentage per annum - ${
                  Benchmark || "NA"
                } + ${MarkupOverBenchmark || "NA"}%) billed on ${
                  billingOccurrence || "NA"
                } basis`;
              }
            }
            return `${Value}`;
          };

          const getTooltipContent = (label, fee) => {
            if (!fee) return null;

            const {
              Type,
              Value,
              Frequency,
              Occurrence,
              Benchmark,
              BenchmarkRate,
              MarkupOverBenchmark,
              NVG,
            } = fee;

            let tooltipContent = `${label} - Type: ${
              Type || "NA"
            }, Frequency: ${Frequency || "NA"}, Occurrence: ${
              Occurrence || "NA"
            }`;
            if (Type !== "NVG") {
              tooltipContent += `, Value: ${Value || "NA"}`;
            }
            if (Type === "NVG") {
              tooltipContent += `, Benchmark: ${
                Benchmark || "NA"
              }, Benchmark Rate: ${
                BenchmarkRate || "NA"
              }, Markup Over Benchmark: ${MarkupOverBenchmark || "NA"}, NVG: ${
                NVG || "NA"
              }`;
            }
            return tooltipContent;
          };

          const integrationFees = rowData?.[0]?.data[0]?.integrationFees
            ? formatFee(rowData[0]?.data[0]?.integrationFees)
            : null;
          const platformCharges = rowData?.[0]?.data[0]?.platformCharges
            ? formatFee(rowData[0]?.data[0]?.platformCharges)
            : null;
          const syndicationFees = rowData?.[0]?.data[0]?.syndicationFees
            ? formatFee(rowData[0]?.data[0]?.syndicationFees)
            : null;

          const integrationFeesTooltip = integrationFees
            ? getTooltipContent(
                "Integration Fees",
                rowData?.[0]?.data[0]?.integrationFees
              )
            : "";
          const platformChargesTooltip = platformCharges
            ? getTooltipContent(
                "Platform Charges",
                rowData?.[0]?.data[0]?.platformCharges
              )
            : "";
          const syndicationFeesTooltip = syndicationFees
            ? getTooltipContent(
                "Syndication Fees",
                rowData?.[0]?.data[0]?.syndicationFees
              )
            : "";

          const fees = [
            {
              fee: integrationFees,
              tooltip: integrationFeesTooltip,
              color: "#22aa48",
            },
            {
              fee: platformCharges,
              tooltip: platformChargesTooltip,
              color: "#2980b9",
            },
            {
              fee: syndicationFees,
              tooltip: syndicationFeesTooltip,
              color: "#8e44ad",
            },
          ];

          const filteredFees = fees.filter((f) => f.fee !== null);

          return (
            <div style={{ cursor: "default", width: "130px" }}>
              {filteredFees.length === 0
                ? "-"
                : filteredFees.map((f, index) => (
                    <React.Fragment key={index}>
                      <span
                        style={{
                          cursor: "pointer",
                          color: f.color,
                        }}
                        title={f.tooltip}
                      >
                        {f.fee}
                      </span>
                      {index < filteredFees.length - 1 && (
                        <span style={{ color: "#000", margin: "0 5px" }}>
                          /
                        </span>
                      )}
                    </React.Fragment>
                  ))}
            </div>
          );
        },
      },
      {
        Header: "Closure Date",
        FullName: "Expected Closure date",
        accessor: "expectedClosureDate",
        filterable: true,
        hideOrder: 7,
        Cell: (cellProps) => {
          const formattedDate = cellProps.value
            ? formatExpectedClosureDate(cellProps.value)
            : "";
          return formattedDate || "";
        },
      },
       {
        Header: "Renewal Date",
        FullName: "Renewal Due Date",
        accessor: "renewableDueDate",
        filterable: true,
        hideOrder: 7,
        Cell: (cellProps) => {
          const formattedDate = cellProps.value
            ? dateFormat(cellProps.value, "DD-MM-YYYY")
            : "";
          return formattedDate || "";
        },
      },
      {
        Header: "FI RM",
        FullName: "",
        accessor: "assignedToFirmUser",
        filterable: true,
        hide: true,
        hideOrder: 12,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          let name = "";
          if (rowData.assignedToFirmUser?.first_name) {
            name +=
              capitalizeFirstLetter(rowData.assignedToFirmUser?.first_name) +
              " ";
          }
          if (rowData.assignedToFirmUser?.last_name) {
            name +=
              capitalizeFirstLetter(rowData.assignedToFirmUser?.last_name) +
              " ";
          }

          return name;
        },
      },
      {
        Header: "Program RM",
        FullName: "Program Manager",
        accessor: "assignedToProgramRmUser",
        filterable: true,
        hideOrder: 11,
        hide: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          let name = "";
          if (rowData.assignedToProgramRmUser?.first_name) {
            name +=
              capitalizeFirstLetter(
                rowData.assignedToProgramRmUser?.first_name
              ) + " ";
          }
          if (rowData.assignedToProgramRmUser?.last_name) {
            name +=
              capitalizeFirstLetter(
                rowData.assignedToProgramRmUser?.last_name
              ) + " ";
          }

          return name;
        },
      },
      // {
      //   Header: "Financiers",
      //   FullName: "",
      //   accessor: "interested",
      //   filterable: true,
      //   hideOrder: 14,
      //   Cell: (cellProps) => {
      //     const rowData = cellProps.row.original;
      //     return (
      //       <span
      //         title={`Interested financiers : ${rowData?.financierCount}, Accepted financiers : ${rowData?.acceptCount}, Rejected financiers : ${rowData?.rejectCount}`}
      //         onMouseEnter={handleMouseEnter}
      //         onMouseLeave={handleMouseLeave}
      //         style={{ cursor: "pointer", color: "#21aa47" }}
      //         onClick={() => {
      //           handleShowFinanciers(rowData);
      //         }}
      //       >
      //         {`I:${rowData.financierCount}, A:${rowData.acceptCount}, R:${rowData.rejectCount}`}
      //       </span>
      //     );
      //   },
      // },
      {
        Header: "Financiers",
        FullName: "",
        accessor: "Financiers",
        filterable: true,
        hideOrder: 14,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
      
          // Combine the two sets of content, with the second content displayed first
          const financierDetails = `
            Existing financiers : ${rowData?.existingFinancierCount}, 
            Referred financiers : ${rowData?.financier.length}\n
            Interested financiers : ${rowData?.financierCount}, 
            Accepted financiers: ${rowData?.acceptCount}, 
            Rejected financiers: ${rowData?.rejectCount}`;
      
          return (
            <div
              style={{ cursor: "pointer", color: "#21aa47" }}
              title={financierDetails} // Tooltip shows combined content with second part first
              onClick={() => {
                // Call both functions in one click
                handleShowFinanciers(rowData);
                handleShowFinanciersDetails(rowData);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >      
              <div style={{ display: 'flex', alignItems: 'center', marginRight: "-80px", gap: "5px" }}>
                <span>{`I: ${rowData.financierCount}, A: ${rowData.acceptCount}, R: ${rowData.rejectCount}`}</span>
                <span style={{ color: "#000" }}>/</span>
                <span>{`Exists: ${rowData.existingFinancierCount}, Referred: ${rowData.financier.length}`}</span>
              </div>
            </div>
          );
        },
      },
      
      {
        Header: "Created On",
        FullName: "",
        accessor: "createdAt",
        filterable: true,
        hideOrder: 10,
        Cell:(cellProps) => {
          return dateFormat(cellProps.value, "DD-MM-YYYY") || "";
        },
      },
      {
        Header: "Status",
        FullName: "",
        accessor: "statusName",
        filterable: true,
        hideOrder: 3,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original;
          return (
            <span
              onClick={() => {
                handleShowStatusBucket(rowData);
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: "pointer", color: "#21aa47" }}
            >
              {rowData?.statusName || ""}
            </span>
          );
        },
      },
      // {
      //   Header: "Financiers Details",
      //   FullName: "",
      //   accessor: "Financiers",
      //   filterable: true,
      //   hideOrder: 13,
      //   Cell: (cellProps) => {
      //     const rowData = cellProps.row.original;
      //     return (
      //       <span
      //         title={`Existing financiers : ${rowData?.existingFinancierCount}, Reffered financiers : ${rowData?.financier.length}`}
      //         onMouseEnter={handleMouseEnter}
      //         onMouseLeave={handleMouseLeave}
      //         style={{ cursor: "pointer", color: "#21aa47" }}
      //         onClick={() => {
      //           handleShowFinanciersDetails(rowData);
      //         }}
      //       >
      //         {`Exists: ${rowData.existingFinancierCount}, Reffered: ${rowData.financier.length}`}
      //       </span>
      //     );
      //   },
      // },
      {
        Header: 'Deal Name',
        FullName: "",
        accessor: 'dealName',
        filterable: true,
        hideOrder: 17,
        hide:true,
        Cell: ({ row }) => {
          const rowData = row.original;
          const entityId = rowData?.id;
          return (
            <a
              href={navigateToDeal(entityId)}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                cursor: "pointer",
                color: "#21aa47",
                width: "170px",
                textDecoration: "none",
              }}
              title={rowData?.dealName || ""}
            >
              <span>{truncateText(rowData?.dealName, 15) || ""}</span>
            </a>
          );
        },
      },
      // {
      //   Header: "Apply Loan",
      //   accessor: "applyLoan",
      //   filterable: false,
      //   hideOrder: 20,
      //   Cell: ({ row }) => {
      //     const rowData = row.original;
      //     const count = rowData?.financierCount || 0;
      //     const handleDetailsClick = () => {
      //       handleRedirect(rowData.id, "Interested");
      //     };
      //     return (
      //       <div>
      //         <p style={{ fontSize: "0.8rem" }}>
      //         <strong>Deal has {count} offer{count !== 1 ? 's' : ''}.{" "}</strong>
      //           <button
      //             onClick={handleDetailsClick}
      //             style={{
      //               cursor: "pointer",
      //               backgroundColor: "transparent",
      //               color: "#21aa47",
      //               border: "none",
      //               textDecoration: "underline",
      //               padding: "0",
      //             }}
      //             title="Click for loan details"
      //           >
      //             Click here for details
      //           </button>
      //         </p>
      //       </div>
      //     );
      //   },
      // },    
      {
        Header: "Action",
        FullName: "",
        accessor: "",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(
            rowData,
            handleShowFinanciers,
            handleShowFinanciersDetails,
            handleShowStatusBucket,
            assignFunc,
            assignToMeFunc,
            downloadDealDetailsPdf,
            dealList,
            setDealList,
            setPagination,
            setStatusCount
          );
        },
      },
    ],
    []
  );
  const handleRedirect = (id, query) => {
    const encrypteddealId = btoa(id.toString());
    navigate(`/${user.roleName}/entity/deal-fin?dealId=${encrypteddealId}&query=${query}`);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen)
  

  const toggleCustom = (tab, ele) => {
    const data = JSON.parse(localStorage.getItem(`selectedFilters_deal_tab_${tab}`));
    setFilterValueTabs(data || [])
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
      setCustomTab(ele);
    }
    if (tab == '4') {
      if (data?.length > 0) {
        if (filterType) {
          getDealForTabs({
            bucket: ele, user,
            filterType,
            filter: data,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else if (dealsIds) {
          getDealForTabs({
            bucket: ele, user,
            decodedealsId,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else {
          getDealForTabs({ bucket: ele, user, filter: data, isShowRenewalCase: isUpcomingTabSelected })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data);
                const { totalItems, totalPages, currentPage } = response.data
                setDealsStatusCount(tab, totalItems)
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
                setDealList([]);
              }
            });
        }
      } else {
        if (filterType) {
          getDealForTabs({
            bucket: ele, user,
            filterType,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else if (dealsIds) {
          getDealForTabs({
            bucket: ele, user,
            decodedealsId,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else {
          getDealForTabs({ bucket: ele, user, isShowRenewalCase: isUpcomingTabSelected })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { currentPage, totalItems } = response.data
                setDealsStatusCount(tab, totalItems)
                setPagination({ pageIndex: currentPage, pageCount: Math.ceil(statusCount.interestedCount / 10), totalRecords: totalItems })
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
                setDealsStatusCount(tab, 0)
              }
            })
        }
      }
    } else if (tab == '1') {
      handlePageChange()
    } else {
      if (data?.length > 0) {
        if (filterType) {
          getDealForTabs({
            bucket: ele, user,
            filterType,
            filter: data,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        }
        else if (dealsIds) {
          getDealForTabs({
            bucket: ele, user,
            decodedealsId,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
                setDealsStatusCount(tab, totalItems)
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else {
          getDealForTabs({ bucket: ele, user, filter: data, isShowRenewalCase: isUpcomingTabSelected })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setDealsStatusCount(tab, totalItems)
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
                setDealsStatusCount(tab, 0)
              }
            })
        }
      } else {
        if (filterType) {
          getDealForTabs({
            bucket: ele, user,
            filterType,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        }
        else if (dealsIds) {
          getDealForTabs({
            bucket: ele, user,
            decodedealsId,
            isShowRenewalCase: isUpcomingTabSelected
          })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
              }
            })
        } else {
          getDealForTabs({ bucket: ele, user, isShowRenewalCase: isUpcomingTabSelected })
            .then((response) => {
              if (response.data) {
                setDealList(response.data.data)
                const { totalItems, totalPages, currentPage } = response.data
                setDealsStatusCount(tab, totalItems)
                setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
              } else {
                setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                setDealList([])
                setDealsStatusCount(tab, 0)
              }
            })
        }
      }
    }
  };


  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filter = filterValue, isShowRenewalCase = isUpcomingTabSelected) => {
    setPageSize(pageSize);
    setLoader(true);
    if (filterType) {
      getDeal({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        filterType,
        user,
        filter,
        isShowRenewalCase
      })
      .then((response) => {
        if (response.data) {
          setDealList(response.data.data);
          const { totalItems, totalPages, currentPage } = response.data;
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
          setDealsStatusCount("1", totalItems)
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
          setDealList([]);
          setDealsStatusCount("1", 0);
        }
      }).catch((e) => {
        // handle error
      }).finally(() => {
        setLoader(false);
      });
    }else if (dealsIds) {
      getDeal({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        filterType,
        user,
        filter,
        decodedealsId,
        isShowRenewalCase
      })
      .then((response) => {
        if (response.data) {
          setDealList(response.data.data);
          const { totalItems, totalPages, currentPage } = response.data;
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
          setDealsStatusCount("1", totalItems)
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
          setDealList([]);
          setDealsStatusCount("1", 0);
        }
      }).catch((e) => {
        // handle error
      }).finally(() => {
        setLoader(false);
      });
    }else {
      getDeal({ page, limit: pageSize, searchKey, columnName, sortingOrder, user, filter, isShowRenewalCase })
      .then((response) => {
        if (response.data) {
          setDealList(response.data.data);
          const { totalItems, totalPages, currentPage } = response.data;
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
          setDealsStatusCount('1', totalItems)
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
          setDealsStatusCount('1', 0)
          setDealList([]);
        }
      }).catch((e) => {
        // handle error
      }).finally(() => {
        setLoader(false);
      });
    }
    
  };


  // useEffect(() => {
  //   const delay = 1;

  //   const timer = setTimeout(() => {
  //     handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filterValue);
  //   }, delay);

  //   return () => clearTimeout(timer);
  // }, [filterValue, pageSize, searchValue]);

  // useEffect(() => {
  //   const delay = 1;

  //   const timer = setTimeout(() => {
  //     handlePageChangeTabs(1, pageSizeTab, searchValue, columnId, sortingOrderStatus, filterValueTabs);

  //   }, delay);

  //   return () => clearTimeout(timer);
  // }, [filterValueTabs, searchValue, pageSizeTab]);

  const handleFilter = (newFilterValue, newPageSize) => {
    setSearchValue("");
    setFilterValue(newFilterValue);
    setPageSize(newPageSize);
    handlePageChange(1, newPageSize, "", columnId, sortingOrderStatus, newFilterValue);
   
  };



  // Filter
  const handleFilterTab = (newFilterValue, newPageSize) => {
    setSearchValue("")
    setFilterValueTabs(newFilterValue)
    setPageSizeTab(newPageSize);
    handlePageChangeTabs(1, pageSizeTab, "", columnId, sortingOrderStatus, newFilterValue);
  }

  const debouncedHandleSearchFilter = debounce((value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value, columnId, sortingOrderStatus, filterValue);
  }, 500);
  
  const debouncedHandleSearchFilterTabs = debounce((value, pageSize) => {
    setSearchValue(value);
    handlePageChangeTabs(1, pageSizeTab, value, columnId, sortingOrderStatus, filterValueTabs);
  }, 500);
  
  const handleSearchFilter = (value, pageSize) => {
    debouncedHandleSearchFilter(value, pageSize);
  };
  
  const handleSearchFilterTabs = (value, pageSize) => {
    debouncedHandleSearchFilterTabs(value, pageSize);
  };

  // Sort
  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder, filterValue)
  }

  // Sort
  const handleSortColumnTabs = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChangeTabs(1, pageSizeTab, searchValue, columnName, sortingOrder, filterValueTabs)
  }

  // Clear
  const handleClearSearch = () => {
    if (filterType) {
      setFilterValue([])
      handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, []);
    } else {
    setSearchValue("")
    setFilterValue([])
    handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, [])
    }
  }


  // Clear
  const handleClearSearchTabs = () => {
    setSearchValue("")
    setFilterValueTabs([])
    handlePageChangeTabs(1, pageSizeTab, "", columnId, sortingOrderStatus, []);
  }


  const handlePageChangeTabs = (page, pageSizeTab, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filter = filterValueTabs, isShowRenewalCase=isUpcomingTabSelected) => {
    
    setPageSizeTab(pageSizeTab);
    if (filterType) {
      getDealForTabs({
        bucket: customTab, page, limit: pageSizeTab, searchKey, columnName, sortingOrder, user, filter , filterType, isShowRenewalCase
      })
      .then((response) => {
        if (response.data) {
          setDealList(response.data.data)
          const { totalItems, totalPages, currentPage } = response.data
          setDealsStatusCount(customActiveTab, totalItems);
          if (customActiveTab == '4') {
            setPagination({ pageIndex: currentPage, pageCount: Math.ceil(statusCount.interestedCount / pageSize), totalRecords: statusCount.interestedCount })
          } else {
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          }
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setDealList([])
          setDealsStatusCount(customActiveTab, 0)
        }
      }).catch((e) => {

      }).finally(() => {
      })
      }
      else if (dealsIds) {
        getDealForTabs({
          bucket: customTab, page, limit: pageSizeTab, searchKey, columnName, sortingOrder, user, filter , decodedealsId, isShowRenewalCase
        })
        .then((response) => {
          if (response.data) {
            setDealList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            setDealsStatusCount(customActiveTab, totalItems)
            if (customActiveTab == '4') {
              setPagination({ pageIndex: currentPage, pageCount: Math.ceil(statusCount.interestedCount / pageSize), totalRecords: statusCount.interestedCount })
            } else {
              setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
            }
          } else {
            setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
            setDealList([])
            setDealsStatusCount(customActiveTab, 0)
          }
        }).catch((e) => {
  
        }).finally(() => {
        })
        }else{
    getDealForTabs({ bucket: customTab, page, limit: pageSizeTab, searchKey, columnName, sortingOrder, user, filter , isShowRenewalCase })
      .then((response) => {
        if (response.data) {
          setDealList(response.data.data)
          const { totalItems, totalPages, currentPage } = response.data
          setDealsStatusCount(customActiveTab, totalItems)
          if (customActiveTab == '4') {
            setPagination({ pageIndex: currentPage, pageCount: Math.ceil(totalItems / pageSize), totalRecords: totalItems })
          } else {
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          }
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setDealsStatusCount(customActiveTab, 0)
          setDealList([])
        }
      }).catch((e) => {

      }).finally(() => {
      })
    }
  }


  const handleShowFinanciers = (ele) => {
    setDealInfo(ele);
    callGetFinancier({ dealId: ele.id })
      .then(async (response) => {
        if (response.code == 200 && response.status) {
          const acceptedFinanciers =
            response?.data.rows?.filter((ele) => ele.isAccepted) || [];
          const interestedFinanciers =
            response?.data.rows?.filter(
              (ele) => ele.isInterested || ele.status == 3
            ) || [];
          const rejectedFinanciers =
            response?.data.rows?.filter((ele) => ele.isRejected) || [];
          setInterestedFinancierList(interestedFinanciers);
          setAcceptedFinancierList(acceptedFinanciers);
          setRejectedFinancierList(rejectedFinanciers);
          const formattedOptions = interestedFinanciers?.map((option) => ({
            label: option.financier.entityName,
            value: option.financierId,
          }));
          const formattedOptions2 = acceptedFinanciers?.map((option) => ({
            label: option.financier.entityName,
            value: option.financierId,
          }));
          const formattedOptions3 = rejectedFinanciers?.map((option) => ({
            label: option.financier.entityName,
            value: option.financierId,
          }));
          let financiersList = await allFinancier({ user });
          if (financiersList) {
            financiersList = financiersList.data;
          }
          if (formattedOptions) {
            setSelectedMulti(formattedOptions);
            const newData = [];
            formattedOptions.forEach((ele) => {
              newData.push(ele.value);
            });
            validation2.setFieldValue("financierId", newData);
          }
          if (formattedOptions2) {
            setSelectedMultiAccept(formattedOptions2);
            const newData = [];
            formattedOptions2.forEach((ele) => {
              newData.push(ele.value);
            });
            const rejectOptions = financiersList?.filter(
              (option) =>
                !formattedOptions2.some(
                  (selected) => selected.value === option.id
                )
            );
            setSelectedMultiRejectOptions(rejectOptions);
            validation2.setFieldValue("acceptedFinancierId", newData);
          }
          if (formattedOptions3) {
            setSelectedMultiReject(formattedOptions3);
            const newData = [];
            formattedOptions3.forEach((ele) => {
              newData.push(ele.value);
            });
            const acceptOptions = financiersList?.filter(
              (option) =>
                !formattedOptions3.some(
                  (selected) => selected.value === option.id
                )
            );
            setSelectedMultiAcceptOptions(acceptOptions);
            validation2.setFieldValue("rejectedFinancierId", newData);
          }
        } else {
          setSelectedMulti([]);
          setSelectedMultiAccept([]);
          setSelectedMultiReject([]);
          setInterestedFinancierList([]);
          setAcceptedFinancierList([]);
          setRejectedFinancierList([]);
          allFinancier({ user })
            .then((response) => {
              if (response.code == 200 && response.status) {
                setFinancierList(response?.data);
                setSelectedMultiRejectOptions(response?.data);
                setSelectedMultiAcceptOptions(response?.data);
              }
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {});

    allFinancier({ user })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setFinancierList(response?.data);
        } else {
          setPrivateSectorBankList([]);
          setAllrBankList([]);
          setNbfcsBankList([]);
          setLenderList([]);
        }
      })
      .catch((error) => {});
    validation2.setFieldValue("dealId", ele.id);
    setSubscribemodal(true);
  };

  const selectedData = (datalist, data) => {
    const newData = [];
    if (data) {
      const dataValues = data.split(",");
      for (const value of dataValues) {
        const foundItem = datalist.find((item) => item.value == value);
        if (foundItem) {
          newData.push(foundItem);
        }
      }
    }
    return newData;
  };

  const handleShowFinanciersDetails = (ele) => {
    setDealInfo(ele);
    getOpenCharges(ele.entity.id)
    dealFinancierDetails({ dealId: ele.id, entityId: ele.entity.id })
      .then(async (response) => {
        if (response.code == 200 && response.status) {
          callFinancierList()
            .then((res) => {
              const formattedOptions = res?.data.map((option) => ({
                label: option.entityName,
                value: option.id,
                type: option.financierType,
              }));

              const allFinanciers = selectedData(
                formattedOptions,
                response.data?.refferedDealFinance?.financier?.join(",")
              );

              const allBanks = allFinanciers.map((elem) => ({
                ...elem,
                category: elem.type,
              }));

              const lenderList =
                response.data.existingFinance?.lenderList || [];
            const unitValue = response.data.existingFinance?.unitValue || '';

              setAllrBankList(allBanks);
              setLenderList(lenderList);
            setUnitValue(unitValue);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
        }
      })
      .catch((error) => {});
    setFinanceirDetailsmodal(true);
  };
  
  const getOpenCharges = (entityId) => {
    callGetProveBaseApi({ entityId })
      .then((response) => {
        if (response?.status && response?.data?.data?.open_charges?.length > 0) {
          setOpenCharges(response.data.data.open_charges)
        } else {
          setOpenCharges([])
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleShowStatusBucket = (ele) => {
    setSelectedDealId(ele.id);
    validation3.setFieldValue("dealStatus", ele.status)
    if(ele.statusName === "Live"){
      setSelectedStatus(true)
      validation3.setFieldValue("renewableDueDate", ele.renewableDueDate || '')
    }else{
      setSelectedStatus(false)
      validation3.setFieldValue("renewableDueDate", ele.renewableDueDate || '')
    }
    
    const statusMapping = {
      'Financier Queue': 1,
      'Submitted By Partner': 2,
      'Draft': 3,
      'Submitted By Customer': 4,
      'Pending E-Signing': 5,
      'Prospect': 6,
      'Meeting Done': 7,
      'WIP': 8,
      'Referred': 9,
      'Queries': 10,
      'Approved': 11,
      'Rejected': 12,
      'On Hold': 13,
      'Pre Sanction Documents': 14,
      'Live': 15,
      'Customer backed out':16,
      'Terms conditions not accepted':17,
      'Deal lost': 18,
      'Sanctioned': 19,
      "Credit Appraisal": 20,
      "GST Karza Completed": 21,
      "PD Done": 22,
    };

    const sortOrder = [
      'Draft',
      'Prospect',
      'Meeting Done',
      'Pending E-Signing',
      'Referred',
      'Financier Queue',
      'Pre Sanction Documents',
      "GST Karza Completed",
      "Credit Appraisal",
      "PD Done",
      'Queries',
      'Sanctioned',
      'Terms conditions not accepted',
      'WIP',
      'Rejected',
      'Live',
      'On Hold',
      'Deal lost',
      'Customer backed out',
      'Submitted By Partner',
      'Submitted By Customer',
      'Approved',
    ];
 
    const product = ele.product
    getDropDownList({ dropdownName: "Deal Status Buckets" })
      .then((response) => {
        if (response.code == 200 && response.status) {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Deal Status Buckets")?.dropdownValues || []
         
          // const allowedStatuses = product === "Inventory funding"
          //   ? ["Draft", "Pending E-Signing", "Pre Sanction Documents", "Credit Appraisal", "Sanctioned", "Rejected", "Live", "GST Karza Completed", "PD Done"]
          //   : Object.keys(statusMapping).filter(status => status !== 'Approved' && status !== 'Rejected' && status !== 'GST Karza Completed' && status !== 'PD Done');

          const filteredDropdownValues = dropdownValues
          // .filter(dv => allowedStatuses.includes(dv.displayName))
          .map(dv => ({
            label: dv.displayName,
            value: statusMapping[dv.displayName]
          }));
          // Map the filtered dropdown values with statusMapping
          const modifiedDropdownValues = filteredDropdownValues.map(dv => ({
            label: dv.displayName,
            value: statusMapping[dv.displayName]
          }));
          filteredDropdownValues.sort((a, b) => {
            const indexA = sortOrder.indexOf(a.label);
            const indexB = sortOrder.indexOf(b.label);
            return indexA - indexB;
          });
          setDealStatusBucketList(filteredDropdownValues)
        }
      }).catch((error) => {
        console.log(error);
      })

    setIsStatusModal(true)
  }

  const downloadDealDetailsPdf = (id) => {
    setToastInfo({
      message: "Downloading please wait...",
      showToast: true,
      role: "success",
    });
    downloadDealPdf({ id: id }).then((response) => {
      if (response.status) {
        let source = `data:application/pdf;base64,${response.data}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = "Deal.pdf";
        link.click();
        setToastInfo({
          message: "Downloaded Successfully",
          showToast: true,
          role: "success",
        });
      } else {
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    });
  };

  const assignFunc = (ele) => {
    validation.setFieldValue("assignedTo", ele.assignedTo);
    validation.setFieldValue("assignedToFirm", ele.assignedToFirm);
    validation.setFieldValue("assignedToProgramRm", ele.assignedToProgramRm);
    callGetCIUser()
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.rows);
        }
      })
      .catch((error) => {});
    validation.setFieldValue("id", ele.id);
    setAssignmodal(true);
  };

  const assignToMeFunc = (ele) => {
    const user = decryptedValue(localStorage.getItem("user"));
    callAssignToMeDealFinancier({ id: ele.id, assignedTo: user.id })
      .then((response) => {
        if (response.status) {
          checkPermissions();
          setToastInfo({
            message: "Deal Assigned Succesfully",
            showToast: true,
            role: "success",
          });
        } else {
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => {});
  };

  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== "string" || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  };

  useEffect(() => {
    setUser(decryptedValue(localStorage.getItem("user")));

    getlistingPreference({ userId: user.id, tableType: "deal" })
      .then((response) => {
        if (response.code == 200 && response.status) {
          const apiColumns = response.data?.columnData || [];
          const mappedColumns = apiColumns.map((apiColumn) => {
            const matchedColumn = columns.find(col => col.accessor === apiColumn.accessor);
            if (matchedColumn) {
              return {
                ...matchedColumn,
                ...apiColumn,
              };
            }
            return apiColumn;
          });
          setSelectedColumns(mappedColumns);
        } else {
          setSelectedColumns([])
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setLoader(true)
    const urlParams = new URLSearchParams(window.location.search);
    const dealsIds = urlParams.get("dealIDs");
    const decodedealsId = atob(dealsIds);
    const name = urlParams.get("name");
    const companyType = urlParams.get("company_type");
    const data = JSON.parse(localStorage.getItem("selectedFilters_deal_tab_1"))
    setFilterValue(data)
    if (data?.length > 0) {
      if (filterType) {
        callStatusCount({ user, filterType, filter: data, isShowRenewalCase: isUpcomingTabSelected  })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      } else if (dealsIds) {
        callStatusCount({ user, decodedealsId, isShowRenewalCase: isUpcomingTabSelected  })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      } else {
        callStatusCount({ user, filter: data, isShowRenewalCase: isUpcomingTabSelected  })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      }

    } else {
      if (filterType) {
        callStatusCount({ user, filterType, isShowRenewalCase: isUpcomingTabSelected  })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      }
      else if (dealsIds) {
        callStatusCount({ user, decodedealsId, isShowRenewalCase: isUpcomingTabSelected  })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      } else {
        callStatusCount({ user, isShowRenewalCase: isUpcomingTabSelected })
          .then((response) => {
            if (response.status) {
              setStatusCount(response.data)
            }
          })
          .catch((error) => {

          }).finally(() => {
            setLoader(false)
          });
      }
    }
    
    
    if(data?.length > 0){
      if(dealsIds){
        getDeal({ user, decodedealsId  })
        .then((response) => {
          if (response.data) {
            setDealList(response.data.data);
            const { totalItems, totalPages, currentPage } = response.data;
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
            setDealsStatusCount("1", totalItems)
          } else {
            setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
            setDealList([]);
            setDealsStatusCount("1", 0);
          }          
        })
        .catch((error) => {

        });
      }else if (filterType) {
        getDeal({ user, filterType, filter: data })
          .then((response) => {
            setDealList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            setDealsStatusCount("1", totalItems)
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          })
          .catch((error) => {
  
          })
        }else{
        getDeal({ user, filter:data })
        .then((response) => {
          setDealList(response.data.data)
          const { totalItems, totalPages, currentPage } = response.data
          setDealsStatusCount('1', totalItems)
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
        })
        .catch((error) => {

        });
      }
      
    }else{
      if (name, companyType) {
        setFilterValue([
          {
            "label": "Company Name",
            "value": "entity_name",
            "condition": "equal",
            "filterValue": [
              name
            ]
          }
        ])
        handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, [
          {
            "label": "Company Name",
            "value": "entity_name",
            "condition": "equal",
            "filterValue": [
              name
            ]
          }
        ]);
  
      } 
      
      else if (filterType) {
        getDeal({ user, filterType })
          .then((response) => {
            setDealList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          })
          .catch((error) => {
  
          });
      }else if (dealsIds) {
        getDeal({ user, decodedealsId })
          .then((response) => {
            setDealList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          })
          .catch((error) => {
  
          });
      } else {
        getDeal({ user })
          .then((response) => {
            setDealList(response.data.data)
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
          })
          .catch((error) => {
  
          });
      }
    }
    
    checkPermissions()
  }, [isUpcomingTabSelected]);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      assignedTo: "",
      assignedToFirm: "",
      assignedToProgramRm: "",
    },
    validationSchema: Yup.object({
      id: Yup.number().required(""),
      assignedTo: Yup.string().required("Please Select User to Assign Deal"),
    }),
    onSubmit: (values) => {
      callAssignDealFinancier({
        id: values.id,
        assignedTo: values.assignedTo,
        assignedToFirm: values.assignedToFirm,
        assignedToProgramRm: values.assignedToProgramRm,
      })
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: "Deal Assigned Succesfully",
              showToast: true,
              role: "success",
            });
            validation.resetForm();
            setAssignmodal(false);
            if (customActiveTab != 1) {
              handlePageChangeTabs(
                pagination.pageIndex || 1,
                pageSizeTab,
                searchValue,
                columnId,
                sortingOrderStatus,
                filterValue
              );
            } else {
              handlePageChange(
                pagination.pageIndex || 1,
                pageSize,
                searchValue,
                columnId,
                sortingOrderStatus,
                filterValueTabs
              );
            }
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {});
    },
  });

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      dealId: "",
      financierId: [],
      acceptedFinancierId: [],
      rejectedFinancierId: [],
    },
    validationSchema: Yup.object({
      dealId: Yup.number().required("Please select Deal"),
      financierId: showInterestedFinDropdown
        ? Yup.array().min(1, "Please Select at least one Financier")
        : Yup.array(),
      acceptedFinancierId: showAcceptedFinDropdown
        ? Yup.array().min(1, "Please Select at least one Financier")
        : Yup.array(),
      rejectedFinancierId: showRejectedFinDropdown
        ? Yup.array().min(1, "Please Select at least one Financier")
        : Yup.array(),
    }),
    onSubmit: (values) => {
      callShowInterestFinancier(values)
        .then((response) => {
          if (response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            validation2.resetForm();
            handleShowFinanciers(dealInfo);
            setSelectedMulti([]);
            if (customActiveTab != 1) {
              handlePageChangeTabs(
                pagination.pageIndex || 1,
                pageSizeTab,
                searchValue,
                columnId,
                sortingOrderStatus,
                filterValue
              );
            } else {
              handlePageChange(
                pagination.pageIndex || 1,
                pageSize,
                searchValue,
                columnId,
                sortingOrderStatus,
                filterValueTabs
              );
            }
            setShowInterestedFinDropdown(false);
            setShowAcceptedFinDropdown(false);
            setShowRejectedFinDropdown(false);
            setSubscribemodal(!subscribemodal);
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {});
    },
  });

  const validation3 = useFormik({
    initialValues: {
      dealId: "",
      dealStatus: "",
      renewableDueDate: "",
    },
    validationSchema: Yup.object({
      dealStatus: Yup.string().required("Please select Deal Status"),
      renewableDueDate: selectedStatus
        ? Yup.string().required("Please select Renewal date")
        : Yup.string(),
    }),

    onSubmit: (values) => {
      const newMandate = {
        dealId: selectedDealId,
        dealStatus: values.dealStatus,
        renewableDueDate: values.renewableDueDate || null,
      };
      addDealStatus(newMandate)
        .then((response) => {
          setToastInfo({
            message: "Status Changed Successfully",
            showToast: true,
            role: "success",
          });
          setIsStatusModal(!isStatusModal);
          validation3.resetForm();
          if (customActiveTab != 1) {
            handlePageChangeTabs(
              pagination.pageIndex || 1,
              pageSizeTab,
              searchValue,
              columnId,
              sortingOrderStatus,
              filterValueTabs
            );
          } else {
            handlePageChange(
              pagination.pageIndex || 1,
              pageSize,
              searchValue,
              columnId,
              sortingOrderStatus,
              filterValue
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  });

  const checkPermissions = async () => {
    const isNewDealpermission = await isPermission(
      "deal_detail",
      "create_permission"
    );
    const isSelectedFieldpermission = await isPermission("select-listing-preference", "create_permission")
    const assignment = await isPermission("assign", "create_permission");
    const isfinop = await isPermission(
      "financier_operations",
      "create_permission"
    );
    const isSDownloadpermission = await isPermission(
      "download_excel_data", 
      "view_permission"
    );
    setIsDownloadPermission(isSDownloadpermission)
    setIsSelectFieldPermission(isSelectedFieldpermission)
    setIsNewDealPermission(isNewDealpermission);
    setIsAssignmentForMePermisssion(assignment);
    setIsFinOperationPermission(isfinop);
  };

  const handleCustomerClicks = () => {
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/addDeal`)
  };

  const createAndDownloadExcel = async (fileName, deals) => {
    if (deals.length === 0) {
        setToastInfo({
            message: "No deals available for download.",
            showToast: true,
            role: "warning",
        });
        return;
    }
    let newData = deals.map((ele) => {
      const rowData = ele?.commercials?.[0]?.data?.[0] || {};
      const formatFeeDetails = (fee, label) => {
          if (!fee) return null;
          const {
              Type, Value, Benchmark, BenchmarkRate, MarkupOverBenchmark, NVG, Frequency, Occurrence
          } = fee;
          let feeDetails = `${label} - Type: ${Type || "NA"}, Frequency: ${Frequency || "NA"}, Occurrence: ${Occurrence || "NA"}`;
          if (Type === "NVG") {
              feeDetails += `, Benchmark: ${Benchmark || "NA"}, Benchmark Rate: ${BenchmarkRate || "NA"}, Markup Over Benchmark: ${MarkupOverBenchmark || "NA"}, NVG: ${NVG || "NA"}`;
          } else {
              feeDetails += `, Value: ${Value || "NA"}`;
          }
          return feeDetails;
      };

      const integrationFees = rowData?.integrationFees ? formatFeeDetails(rowData.integrationFees, 'Integration Fees') : null;
      const platformCharges = rowData?.platformCharges ? formatFeeDetails(rowData.platformCharges, 'Platform Charges') : null;
      const syndicationFees = rowData?.syndicationFees ? formatFeeDetails(rowData.syndicationFees, 'Syndication Fees') : null;    
      const commercialFeesDetails = [integrationFees, platformCharges, syndicationFees].filter(Boolean).join(" / ");
      
      const associatedAnchor = ele.dealType === 'Counterparty' ? ele.anchor?.entityName || "" : "";
      
      const financierNames = ele.financierData 
        ? ele.financierData.map(financier => financier.name).join(', ')
        : '';

        return {
            "Entity Name": ele.entity?.entityName || "",
            "Turnover": ele.entity?.turn_over ? `₹ ${formatNumberWithCommas(ele.entity.turn_over)}` : "",
            "Associated Anchor": associatedAnchor,
            "Loan Requirement": formatNumberWithCommas(ele.loanRequirement)|| "",
            "Credit Rating": ele.credit_rating || "",
            "Product": ele.product || "",
            "Product Type": ele.productType || "", 
            "Sub Product": ele.subProduct || "", 
            "status": ele.statusName || "",
            "RM": `${ele.assignedToUser?.first_name || ""} ${ele.assignedToUser?.last_name || ""}`.trim(),
            "Program RM": `${ele.assignedToProgramRmUser?.first_name || ""} ${ele.assignedToProgramRmUser?.last_name || ""}`.trim(),
            "FI RM": `${ele.assignedToFirmUser?.first_name || ""} ${ele.assignedToFirmUser?.last_name || ""}`.trim(),
            "Recommended financier": financierNames,
            "Created At": ele.createdAt ? dateFormat(ele.createdAt, "DD-MM-YYYY") : "",
            "Commercials": commercialFeesDetails || "",
          }
    });
  
    const ws = XLSX.utils.json_to_sheet(newData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Deals');
    const buffer = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.download = `${fileName}.xlsx`;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadData = () => {
    const fileName = "Deals_List";
    let apiFunc = getDeal;  
    let params = {
      page: 1,
      limit: pagination.totalRecords || 10000,
      searchKey: searchValue || "",
      columnName: sortingOptions.column,
      sortingOrder: sortingOptions.isAsc ? "asc" : "desc",
      filter: filterValue,
      user
    };
    const queryParams = new URLSearchParams(window.location.search);
    const dealIdsEncoded = queryParams.get('dealIDs');
   
    if (dealIdsEncoded) {
      try {
        const decodedDealIds = atob(dealIdsEncoded);
        params.decodedealsId = decodedDealIds;
      } catch (error) {
        console.error("Error decoding deal IDs:", error);
      }
    }

    if (customActiveTab !== "1") {
      apiFunc = getDealForTabs;
      params.bucket = customTab;
      params.filter = filterValueTabs;
    }
  
    apiFunc(params).then((response) => {
      if (response.data && response.data.data) {
        const deals = response.data.data;
        createAndDownloadExcel(fileName, deals);
        setToastInfo({
          message: "File downloaded successfully!",
          showToast: true,
          role: "success",
        });
      } else {
        setToastInfo({
          message: "No deals available for download.",
          showToast: true,
          role: "warning",
        });
      }
    }).catch((error) => {
      setToastInfo({
        message: "Error fetching deals for download.",
        showToast: true,
        role: "error",
      });
    });
  };
  


  const buttonSection = (
    <div className="d-flex justify-content-end" >
    <div>
      {isSelectFieldPermission && (
        <>
        <div className="d-flex">
          <Button
              type="button"
              color="light"
              className="btn-rounded mb-2 me-2 ms-2 border-success"
              onClick={toggleModal}
            >
              <i className="mdi mdi-table-column-plus-before me-2" />
              {'Select Fields'}
            </Button>
            
            </div>
            {isModalOpen && (
            <div
              className="filter-popup display-flex justify-content-end vertical-scroll"
              style={{
                position: 'absolute',
                top: '2.4rem',
                right: '0',
                background: 'white',
                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                zIndex: 2000,
                padding: '10px',
                borderRadius: '5px',
                minHeight: '350px',
                maxHeight: '400px',
                overflow: 'auto',
                maxWidth: '600px',
                width: '100%',
              }}
            >
              <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                <h6 style={{ margin: 0 }}>Drag and drop columns from Available to Selected for your preference</h6>
                <button
                  type="button"
                  onClick={toggleModal} // Close the dropdown
                  style={{
                    border: 'none',
                    background: 'transparent',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                  }}
                >
                </button>
                
              </div>
              <DndProvider backend={isMobile ? TouchBackend : HTML5Backend} options={{ enableMouseEvents: true }}>
                <ColumnDragDrop columns={columns} onApply={setSelectedColumns} toggleModal={toggleModal} tableType="deal" />
              </DndProvider>
            </div>
          )}
          </>
      )}
       
    </div>
    <div>
    {isDownloadPermission && (
        <>
         <Button
            id="downloadTooltip"
            type="button"
            color="light"
            className="btn-rounded mb-2 me-2 ms-2 border-success"
            onClick={() => {             
              handleDownloadData();
            }}
          >
            <i className="fa fa-download"></i>
           
          </Button>
          <UncontrolledTooltip placement="top" target="downloadTooltip">
          Download Deal List Data
         </UncontrolledTooltip>
         </>
         )} 
      </div>
    </div>
  );

  const handleMulti = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation2.setFieldValue("financierId", newData);
    setSelectedMulti(selectedOptions);
  };

  const handleMultiAccept = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation2.setFieldValue("acceptedFinancierId", newData);
    setSelectedMultiAccept(selectedOptions);
    const rejectOptions = financierList?.filter(
      (option) =>
        !selectedOptions.some((selected) => selected.value === option.id)
    );
    setSelectedMultiRejectOptions(rejectOptions);
  };

  const handleMultiReject = (selectedOptions) => {
    const newData = [];
    selectedOptions.forEach((ele) => {
      newData.push(ele.value);
    });
    validation2.setFieldValue("rejectedFinancierId", newData);
    setSelectedMultiReject(selectedOptions);
    const acceptOptions = financierList?.filter(
      (option) =>
        !selectedOptions.some((selected) => selected.value === option.id)
    );
    setSelectedMultiAcceptOptions(acceptOptions);
  };

  const handleStatusChange = (e) => {
    const { value } = e.target;
    if (value == "15") {
      setSelectedStatus(true);
    } else {
      setSelectedStatus(false);
    }

    validation3.handleChange(e);
    setSearchValue("");
  };

  const handleRenewableDueDateChange = (date) => {
    setRenewableDueDate(date);
    validation3.setFieldValue("renewableDueDate", date);
  };

  const setDealsStatusCount = (tab, count) => {
    setStatusCount((prevStatusCount) => {
      let updatedStatusCount = { ...prevStatusCount }; // Spread the previous state
  
      switch (tab) {
        case '1':
          updatedStatusCount.allDealsCount = count;
          break;
        case '2':
          updatedStatusCount.CIQueueCount = count;
          break;
        case '6':
          updatedStatusCount.liveStatusCount = count;
          break;
        case '3':
          updatedStatusCount.financierQueueCount = count;
          break;
        case '4':
          updatedStatusCount.interestedCount = count;
          break;
        case '5':
          updatedStatusCount.assignedToMeCount = count;
          break;
        default:
          return prevStatusCount; // If no case matches, return the previous state
      }
  
      return updatedStatusCount; // Return the updated status count
    });
  };
  

  const formatLenderName = (type) => {
    if (!type) return type;
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" ");
  };

  const formatAmount = (amount, unitValue) => {
    if (amount) {
      switch (unitValue?.toLowerCase()) {
        case 'crores':
          return `₹ ${amount} Cr`;
        case 'lakhs':
          return `₹ ${amount} Lakh`;
        case 'thousands':
          return `₹ ${amount} Th`;
        default:
          return `₹ ${amount}`;  
      }
    }

    return amount;
    };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-4">
      {/* Breadcrumbs on the left */}
      <Breadcrumbs title="DEAL LIST" />

      {/* Button on the right */}
      <div>
      {isNewDealPermission && (
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-4"
          onClick={handleCustomerClicks}
          title="Create a new deal"
        >
          <i className="mdi mdi-plus me-1" />
          {'New Deal'}
        </Button>
      )}

       <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-4 no-hover-fill"
                onClick={() => {
                  handlePageChange(
                    pagination.pageIndex || 1,
                    pageSize,
                    searchValue,
                    columnId,
                    sortingOrderStatus,
                    filterValue,
                    !isUpcomingTabSelected
                  );
                  setIsUpcomingTabSelected(!isUpcomingTabSelected)
                }}
          outline
        >
          {!isUpcomingTabSelected ? 'Show ' : 'Hide ' }
          {'Upcoming Renewals'}({(statusCount.renewalDealsCount)})
        </Button>
      </div>
    </div>
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1", 0);
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">All({statusCount?.allDealsCount})</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2", "ci_queue");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">In CI Queue({statusCount?.CIQueueCount})</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "6",
                        })}
                        onClick={() => {
                          toggleCustom("6", "live_status");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Live Deals({statusCount?.liveStatusCount})</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "3",
                        })}
                        onClick={() => {
                          toggleCustom("3", 'financier_admin');
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-rupee-sign"></i>
                        </span>
                        <span className="d-none d-sm-block">In Financier Queue({statusCount?.financierQueueCount})</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "4",
                        })}
                        onClick={() => {
                          toggleCustom("4", 4);
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-heart"></i>
                        </span>
                        <span className="d-none d-sm-block">Interest Shown({statusCount?.interestedCount})</span>
                      </NavLink>
                    </NavItem>
                    { user.roleName !== "reporting_manager" && (
                      <> <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "5",
                        })}
                        onClick={() => {
                          toggleCustom("5", "assignedToMe");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Assigned To Me({statusCount?.assignedToMeCount})</span>
                      </NavLink>
                    </NavItem>
                      </>
                    )} 
                   

                  </Nav>

                  <TabContent
                    activeTab={customActiveTab}
                    className="text-muted"
                  >
                     {/* <ColumnDragDrop columns={columns} onApply={setSelectedColumns} /> */}
                     <TabPane tabId="1">
                      <TableContainerV1
                        tabIndex={1}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                        handleSearchFilter={handleSearchFilter}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumn}
                        handleClearSearch={handleClearSearch}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilter}
                        activeTab={customActiveTab}
                      />
                    </TabPane>

                    <TabPane tabId="2">
                      <TableContainerV1
                        tabIndex={2}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChangeTabs}
                        handleSearchFilter={handleSearchFilterTabs}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumnTabs}
                        handleClearSearch={handleClearSearchTabs}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilterTab}
                        activeTab={customActiveTab}
                      />
                    </TabPane>

                    <TabPane tabId="3">
                      <TableContainerV1
                        tabIndex={3}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChangeTabs}
                        handleSearchFilter={handleSearchFilterTabs}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumnTabs}
                        handleClearSearch={handleClearSearchTabs}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilterTab}
                        activeTab={customActiveTab}
                      />
                    </TabPane>

                    <TabPane tabId="4">
                      <TableContainerV1
                        tabIndex={4}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChangeTabs}
                        handleSearchFilter={handleSearchFilterTabs}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumnTabs}
                        handleClearSearch={handleClearSearchTabs}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilterTab}
                        activeTab={customActiveTab}
                      />
                    </TabPane>

                    <TabPane tabId="5">
                      <TableContainerV1
                        tabIndex={5}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChangeTabs}
                        handleSearchFilter={handleSearchFilterTabs}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumnTabs}
                        handleClearSearch={handleClearSearchTabs}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilterTab}
                        activeTab={customActiveTab}
                      />
                    </TabPane>
                    <TabPane tabId="6">
                      <TableContainerV1
                        tabIndex={6}
                        columns={selectedColumns.length > 0 ? selectedColumns : columns}
                        data={dealList}
                        pagination={pagination}
                        handlePageChange={handlePageChangeTabs}
                        handleSearchFilter={handleSearchFilterTabs}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumnTabs}
                        handleClearSearch={handleClearSearchTabs}
                        className="custom-header-css"
                        tableFor="deal"
                        handleFilter={handleFilterTab}
                        activeTab={customActiveTab}
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal 
        isOpen={financeirDetailsmodal ||subscribemodal}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setFinanceirDetailsmodal(false);
          setSubscribemodal(false);
        }}
        size="lg"
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setFinanceirDetailsmodal(false);
              setSubscribemodal(false);
            }}
          ></ModalHeader>
        </div>
        <div className="vertical-scroll">
          <div className="modal-body" style={{ borderRadius: "5px" }}>
            {lenderList.length === 0 && allBankList.length === 0 && (
              <div className="text-success font-size-14 text-center mt-4 mb-4">
                No Financier data available for both Existing and Referred financiers
              </div>
            )}

            {openCharges.length > 0 && (
              <div>
                <div className="financier-header">Open charges</div>
                <Table className="table table-bordered table-striped mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Id</th>
                      <th>Date</th>
                      <th>Holder name</th>
                      <th>Amount</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {openCharges?.map((ele, index) => (
                      <tr key={uId()}>
                        <td>{ele?.id}</td>
                        <td>{ele?.date}</td>
                        <td>{ele?.holder_name}</td>
                        <td>{formatNumberToCrores(ele?.amount)}</td>
                        <td>{ele?.type}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}

            {lenderList.length === 0 && allBankList.length > 0 && (
              <div className="text-success font-size-14 text-center mt-4 mb-4">
                No Existing Financier details available
              </div>
            )}

            {lenderList.length > 0 && (
              <div>
                <div className="financier-header mt-4">Existing Financiers</div>
                <Table className="table table-bordered table-striped mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Lender Name</th>
                      <th>Type</th>
                      <th>Sanctioned Amount</th>
                      <th>Outstanding Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lenderList?.map((ele, index) => (
                      <tr key={uId()}>
                        <td>{ele?.lenderName}</td>
                        <td>{formatLenderName(ele?.type)}</td>
                        <td>{formatAmount(ele?.sanctionedAmount, unitValue)}</td>
                        <td>{formatAmount(ele?.outstandingAmount, unitValue)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
            {allBankList.length === 0 && lenderList.length > 0 && (
              <div className="text-success font-size-14 text-center mt-4 mb-4">
                No Referred Financier details available
              </div>
            )}
            {allBankList.length > 0 && (
              <div>
                <div className="financier-header mt-4">Referred Financiers</div>
                {(() => {
                  let numberOfColumns = 1;

                  if (allBankList.length % 3 === 0) {
                    numberOfColumns = 3;
                  } else if (allBankList.length % 2 === 0) {
                    numberOfColumns = 2;
                  } else if (allBankList.length % 2 !== 0 && allBankList.length % 2 !== 0) {
                    numberOfColumns = 2;
                  }

                  const columnSize = Math.ceil(allBankList.length / numberOfColumns);
                  const columns = Array.from({ length: numberOfColumns }, (_, index) =>
                    allBankList.slice(index * columnSize, (index + 1) * columnSize)
                  );

                  return (
                    <Table className="table table-bordered table-striped mb-0">
                      <tbody>
                        <tr>
                          {columns.map((column, index) => (
                            <td key={index}>
                              <ul className="financier-list">
                                {column.map((ele) => (
                                  <li key={uId()}>{ele?.label}</li>
                                ))}
                              </ul>
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </Table>
                  );
                })()}
              </div>
            )}
          </div>

          <div className="mb-3 m-4" >
            <hr className="thin-separator mb-3 mt-3"></hr>
          </div>

          <div className="mb-3 m-4" >
            {interestedFinancierList.length > 0 && (<div>
              <div className="financier-header" style={{ marginBottom: '-12px', marginTop: '10px' }}>Interested Financier</div>
              <div style={{backgroundColor:'#f8f9fa'}} className="mt-3">
              <ul>
                {interestedFinancierList?.map((ele, index) => (
                  <li className={`font-size-16 ${index == 0 ? 'mt-0' : 'mt-1'} d-sm-flex align-items-center gap-1 p-1`} key={uId()}>
                    <div className="d-sm-flex align-items-center gap-1">
                      <div>
                        {ele?.financier?.entityName}
                      </div>
                      <div className="font-size-12 text-secondary" style={{ marginTop: '-2px' }}>({formatDate(ele?.interestedAt)})</div>
                    </div>
                  </li>
                ))}
              </ul>
              </div>
            </div>)}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation2.handleSubmit()
                  return false
                }}
              >
                <Col xl={12}  >
                  <div className="form-label grey font-size-16 mt-3">Add financiers who are interested in the deals</div>
                  <Select
                    name="financierId"
                    value={selectedMulti}
                    isMulti={true}
                    onChange={handleMulti}
                    className={`select-dropdown ${validation2.touched.financierId &&
                      validation2.errors.financierId
                      ? "is-invalid"
                      : ""
                      }`}
                    options={financierList.map((option, index) => ({
                      label: option.entityName,
                      value: option.id,
                    }))}
                  />
                  {validation2.touched.financierId && validation2.errors.financierId ? (
                    <FormFeedback type="invalid">
                      {validation2.errors.financierId}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Form>
            )}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (<hr className="thin-separator mb-3 mt-3"></hr>)}

            {acceptedFinancierList.length > 0 && (<div>
              <div className="financier-header" style={{ marginBottom: '-12px' }}>Accepted Financier</div>
              <div style={{ backgroundColor: '#f8f9fa'}} className="mt-3">
                <ul>
                  {acceptedFinancierList?.map((ele, index) => (
                    <li className={`font-size-16 ${index == 0 ? 'mt-0' : 'mt-1'} d-sm-flex align-items-center gap-1 p-1`} key={uId()}>
                      <div className="d-sm-flex align-items-center gap-1">
                        <div>
                          {ele?.financier?.entityName}
                        </div>
                        <div className="font-size-12 text-secondary" style={{ marginTop: '-2px' }}>({formatDate(ele?.acceptedAt)})</div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>)}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation2.handleSubmit()
                  return false
                }}
              >
                <Col xl={12} >
                  <div className="form-label grey font-size-16 mt-3">Add financiers who have accepted the deals</div>
                  <Select
                    name="acceptedFinancierId"
                    value={selectedMultiAccept}
                    isMulti={true}
                    onChange={handleMultiAccept}
                    className={`select-dropdown ${validation2.touched.acceptedFinancierId &&
                      validation2.errors.acceptedFinancierId
                      ? "is-invalid"
                      : ""
                      }`}
                    options={selectedMultiAcceptOptions.map((option, index) => ({
                      label: option.entityName,
                      value: option.id,
                    }))}
                  />
                  {validation2.touched.acceptedFinancierId && validation2.errors.acceptedFinancierId ? (
                    <FormFeedback type="invalid">
                      {validation2.errors.acceptedFinancierId}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Form>
            )}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (<hr className="thin-separator mb-3 mt-3"></hr>)}

            {rejectedFinancierList.length > 0 && (<div>
              <div className="financier-header" style={{ marginBottom: '-12px' }}>Rejected Financier</div>
              <div style={{ backgroundColor: '#f8f9fa'}} className="mt-3">
                <ul>
                  {rejectedFinancierList?.map((ele, index) => (
                    <li className={`font-size-16 ${index == 0 ? 'mt-0' : 'mt-1'} d-sm-flex align-items-center gap-1 p-1`} key={uId()}>
                      <div className="d-sm-flex align-items-center gap-1">
                        <div>
                          {ele?.financier?.entityName}
                        </div>
                        <div className="font-size-12 text-secondary" style={{ marginTop: '-2px' }}>({formatDate(ele?.rejectedAt)})</div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>)}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation2.handleSubmit()
                  return false
                }}
              >
                <Col xl={12} >
                  <div className="form-label grey font-size-16 mt-3">Add financiers who have rejected the deals</div>
                  <Select
                    name="rejectedFinancierId"
                    value={selectedMultiReject}
                    isMulti={true}
                    onChange={handleMultiReject}
                    className={`select-dropdown ${validation2.touched.rejectedFinancierId &&
                      validation2.errors.rejectedFinancierId
                      ? "is-invalid"
                      : ""
                      }`}
                    options={selectedMultiRejectOptions.map((option, index) => ({
                      label: option.entityName,
                      value: option.id,
                    }))}
                  />
                  {validation2.touched.rejectedFinancierId && validation2.errors.rejectedFinancierId ? (
                    <FormFeedback type="invalid">
                      {validation2.errors.rejectedFinancierId}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Form>
            )}

            {isAssignmentForMePermisssion && (dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (<Row>
              <Col sm="12" >
                <div className="d-flex gap-2 justify-content-end mt-2 mb-3">
                  <Button
                    type="button"
                    color='secondary'
                    className="btn-rounded me-2 mt-2"
                    outline
                    onClick={() => {
                      setShowInterestedFinDropdown(false)
                      setShowAcceptedFinDropdown(false)
                      setShowRejectedFinDropdown(false)
                      setSubscribemodal(false);
                      setFinanceirDetailsmodal(false)
                      validation2.resetForm()
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color='success'
                    className="btn-rounded me-2 mt-2"
                    onClick={() => { validation2.handleSubmit() }}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>)}

            {(rejectedFinancierList.length == 0 && acceptedFinancierList.length == 0 && interestedFinancierList.length == 0 && (dealInfo?.status == 3 || dealInfo?.status == 4 || dealInfo?.status == 2 || dealInfo?.status == 5)) && (
              <div className="text-success font-size-14 text-center">Deals in Draft, Pending E-Signing and Submitted by Customer status cannot have financier operations like accept, reject, or show interest. Please change the deal status in order to allow these options.</div>
            )}

            {(rejectedFinancierList.length == 0 && acceptedFinancierList.length == 0 && interestedFinancierList.length == 0) && !(dealInfo?.assignedTo == user.id || dealInfo?.createdBy == user.id || dealInfo?.assignedToFirm == user.id || dealInfo?.assignedToProgramRm == user.id || isFinOperationPermission) && (dealInfo?.status != 3 && dealInfo?.status != 4 && dealInfo?.status != 2 && dealInfo?.status != 5) && (<div className="text-success font-size-14 text-center">
              Only deals assigned to you or created by you can have financier operations such as accept, reject, or show interest performed.
            </div>)}
          </div>
        </div>
      </Modal>


      <Modal
        isOpen={assignmodal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setAssignmodal(!assignmodal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setAssignmodal(!assignmodal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select User to Assign Deal</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">RM</Label>
                    <Input
                      name="assignedTo"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.assignedTo || null}
                      invalid={
                        validation.touched.assignedTo &&
                        validation.errors.assignedTo
                      }
                    >
                      <option value="" disabled>
                        Select RM
                      </option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) +
                            " " +
                            (option.lastName
                              ? capitalizeFirstLetter(option.lastName)
                              : "")}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.assignedTo &&
                    validation.errors.assignedTo ? (
                      <FormFeedback type="invalid">
                        {validation.errors.assignedTo}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">
                      FI RM
                    </Label>
                    <Input
                      name="assignedToFirm"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.assignedToFirm || null}
                      invalid={
                        validation.touched.assignedToFirm &&
                        validation.errors.assignedToFirm
                      }
                    >
                      <option value="">Select FI RM</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) +
                            " " +
                            (option.lastName
                              ? capitalizeFirstLetter(option.lastName)
                              : "")}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.assignedToFirm &&
                    validation.errors.assignedToFirm ? (
                      <FormFeedback type="invalid">
                        {validation.errors.assignedToFirm}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">
                      Program Manager
                    </Label>
                    <Input
                      name="assignedToProgramRm"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.assignedToProgramRm || null}
                      invalid={
                        validation.touched.assignedToProgramRm &&
                        validation.errors.assignedToProgramRm
                      }
                    >
                      <option value="">Select Program Manager</option>
                      {userList?.map((option) => (
                        <option key={uId()} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) +
                            " " +
                            (option.lastName
                              ? capitalizeFirstLetter(option.lastName)
                              : "")}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.assignedToProgramRm &&
                    validation.errors.assignedToProgramRm ? (
                      <FormFeedback type="invalid">
                        {validation.errors.assignedToProgramRm}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Row>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Assign
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isStatusModal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsStatusModal(!isStatusModal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsStatusModal(!isStatusModal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select Deal Status</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation3.handleSubmit();
                    return false;
                  }}
                >
                  <Col xl={12}>
                    <Input
                      name="dealStatus"
                      type="select"
                      onChange={handleStatusChange}
                      onBlur={validation3.handleBlur}
                      value={
                        validation3.values.dealStatus != 11 
                          ? validation3.values.dealStatus
                          : ""
                      }
                      invalid={
                        validation3.touched.dealStatus &&
                        !!validation3.errors.dealStatus
                      }
                    >
                      <option value="" selected>
                        Select Deal Status
                      </option>
                      {dealStatusBucketList?.map((option) => (
                        <option key={uId()} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                    {validation3.touched.dealStatus &&
                    validation3.errors.dealStatus ? (
                      <FormFeedback type="invalid">
                        {validation3.errors.dealStatus}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  {selectedStatus && (
                    <Col xl="12">
                      <Label className="required-sign form-label mt-4">
                        Renewal Due Date <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="renewableDueDate"
                        type="date"
                        onChange={validation3.handleChange}
                        onBlur={validation3.handleBlur}
                        value={
                          formatDateString1(
                            validation3.values.renewableDueDate
                          ) || ""
                        }
                        invalid={
                          validation3.touched.renewableDueDate &&
                          validation3.errors.renewableDueDate
                        }
                        // max={currentDate}
                      />
                      {validation3.touched.renewableDueDate &&
                      validation3.errors.renewableDueDate ? (
                        <FormFeedback type="invalid">
                          {validation3.errors.renewableDueDate}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  )}
                  <Row>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Submit
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modal}
        role="<dialog>"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModal(!modal);
        }}
      ></Modal>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching details" />
    </React.Fragment>
  );
};

export default DealList;




const formatDate = (oldDate) => {
  if (!oldDate) return "";
  const isoDateString = oldDate;
  const date = new Date(isoDateString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const formattedDate = date.toLocaleDateString(undefined, options);

  return formattedDate;
};
